import { cache } from 'react';
import axios from 'axios';
import { getServerSession } from 'next-auth';

import { authOptions } from '@/lib/auth';
import { SERVER_API_URL } from '@/lib/public-api-url';

/**
 * Per-request memoization of getServerSession (JWT decode + cookie read).
 * Reader SSR and other pages often call createServerApi many times; without
 * cache each call re-parses the session token.
 */
export const getServerSessionCached = cache(async () => {
  return getServerSession(authOptions);
});

/**
 * Shared axios client for the current RSC/request. Dedupes session lookup and
 * avoids recreating clients when multiple *ReqSSR helpers run in one render.
 */
export const createServerApi = cache(async () => {
  const session = await getServerSessionCached();

  return axios.create({
    baseURL: SERVER_API_URL,
    headers: {
      ...(session?.accessToken && {
        Authorization: `Bearer ${session.accessToken}`,
      }),
    },
  });
});
